import get from 'lodash/get';
import { utcToZonedTime, format } from 'date-fns-tz';
import { isBefore, isSameDay, isSameHour, isSameMinute } from 'date-fns';
import enUS from 'date-fns/locale/en-US';

export const GENDERS = {
  M: 'MALE',
  F: 'FEMALE',
  X: 'NON_BINARY',
  U: 'NOT_SPECIFIED',
};

const ETHNICITY = {
  UK: 'UNKNOWN',
  AI: 'AMERICAN_INDIAN',
  AS: 'ASIAN',
  BA: 'BLACK',
  FI: 'FILIPINO',
  HI: 'HISPANIC',
  MR: 'MULTI_RACIAL',
  OT: 'OTHER',
  PI: 'PACIFIC_ISLANDER',
  WH: 'WHITE',
};

export const GRADE_LEVEL = {
  '9': 'GRADE_9',
  '10': 'GRADE_10',
  '11': 'GRADE_11',
  '12': 'GRADE_12',
};

export const studentProfile = (user) => {
  const gender = get(user, 'gender', 'U');
  const zipCode = get(user, 'address.zip', '');
  const state = get(user, 'address.state', '');
  const gradeLevel = get(user, 'gradeLevel', '');
  const gpa = parseFloat(get(user, 'defaultGpa', null));
  const ethnicity = get(user, 'ethnicity', 'UK');

  return {
    gender: GENDERS[gender],
    zipCode: zipCode,
    state: state,
    gradeLevel: GRADE_LEVEL[gradeLevel],
    gpa: Number.isNaN(gpa) ? undefined : gpa,
    ethnicity: ETHNICITY[ethnicity],
  };
};

export function parseGraphQL(searchCollegeEvents) {
  const events = parseEvents(searchCollegeEvents);
  return sortEventsByDate(sortEventsByCollegeName(events));
}

function parseEvents(searchCollegeEvents) {
  if (!searchCollegeEvents) return [];
  return searchCollegeEvents.map((event) => ({
    ...event.node.collegeEvent,
    recommended: event.node.recommended,
    recommendedAudienceProfile: event.node.recommendedAudienceProfile,
    college: event.node.college,
  }));
}

function sortEventsByCollegeName(events, asc = true) {
  const order = asc ? 1 : -1;
  return events.sort((a, b) => {
    if (a.college.name === b.college.name) return 0;
    return a.college.name < b.college.name ? -1 * order : order;
  });
}

function sortEventsByDate(events, asc = true) {
  const order = asc ? 1 : -1;
  return events.sort((a, b) => {
    const dateForA = utcToZonedTime(a.eventDateTime, a.timezone);
    const dateForB = utcToZonedTime(b.eventDateTime, b.timezone);

    if (
      isSameDay(dateForA, dateForB) &&
      isSameHour(dateForA, dateForB) &&
      isSameMinute(dateForA, dateForB)
    ) {
      return 0;
    }

    return isBefore(dateForA, dateForB) ? -1 * order : order;
  });
}

export function parseEvent(event) {
  const location = event.collegeEventLocation;

  const containsHttpOrHttps = /^https?:\/\//.test(event.registrationUrl);
  const registrationUrl = containsHttpOrHttps
    ? event.registrationUrl
    : 'http://' + event.registrationUrl;

  const dateStartFormatted = utcToZonedTime(event.eventDateTime, event.timezone);
  const dateEndFormatted = utcToZonedTime(event.eventEndDateTime, event.timezone);

  const fullDay = format(dateStartFormatted, 'eeee');
  const nrMonth = format(dateStartFormatted, 'MMM d');
  const startHour = format(dateStartFormatted, 'h:mm aa');
  const endHour = format(dateEndFormatted, 'h:mm aa');
  const timezone = format(dateEndFormatted, 'zzz', {
    timeZone: event.timezone,
    locale: enUS,
  });

  return {
    location,
    registrationUrl,
    fullDay,
    nrMonth,
    startHour,
    endHour,
    timezone,
  };
}
